import { OrganizationAccountTypeEnum } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';

/** The glyph that marks an organisation's account type in the switcher. */
export const orgIcon = (accountType: OrganizationAccountTypeEnum) => {
  if (accountType === OrganizationAccountTypeEnum.parent) return Icons.network;
  if (accountType === OrganizationAccountTypeEnum.staff) return Icons.shield;
  return Icons.building;
};
